<template>
    <div>
        <section class="container mt-3 py-3">
            <h4>Tabs</h4>
            <!-- Implementación -->
            <div class="mt-3 mb-4">
                <ul class="tabs-default-siahe nav nav-tabs" id="myTab" role="tablist">
                    <li class="nav-item" role="presentation">
                        <button class="nav-link active body-3 montserrat-400" id="item1-tab" data-bs-toggle="tab" data-bs-target="#item1-tab-pane" type="button" role="tab" aria-controls="item1-tab-pane" aria-selected="true">Item 1</button>
                    </li>
                    <li class="nav-item" role="presentation">
                        <button class="nav-link body-3 montserrat-400" id="item2-tab" data-bs-toggle="tab" data-bs-target="#item2-tab-pane" type="button" role="tab" aria-controls="item2-tab-pane" aria-selected="false">Item 2</button>
                    </li>
                    <!-- <li class="nav-item" role="presentation">
                        <button class="nav-link body-3 montserrat-400" id="disabled-tab" data-bs-toggle="tab" data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false" disabled>Disabled</button>
                    </li> -->
                </ul>
                <div class="tab-content mt-2" id="myTabContent">
                    <div class="tab-pane fade show active" id="item1-tab-pane" role="tabpanel" aria-labelledby="item1-tab" tabindex="0">Contenido item 1</div>
                    <div class="tab-pane fade" id="item2-tab-pane" role="tabpanel" aria-labelledby="item2-tab" tabindex="0">Contenido item 2</div>
                    <!-- <div class="tab-pane fade" id="disabled-tab-pane" role="tabpanel" aria-labelledby="disabled-tab" tabindex="0">...</div> -->
                </div>
            </div>
            <p class="text-dark my-0">Código para la implementación de tabs</p>
            <!-- CODIGO QUE SE MUESTRA -->
            <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><ul class="tabs-default-siahe nav nav-tabs" id="myTab" role="tablist">
    <li class="nav-item" role="presentation">
        <button 
            class="nav-link active body-3 montserrat-400" 
            id="item1-tab" 
            data-bs-toggle="tab" data-bs-target="#item1-tab-pane" 
            type="button" role="tab" 
            aria-controls="item1-tab-pane" aria-selected="true">Item 1
        </button>
    </li>
    <li class="nav-item" role="presentation">
        <button 
            class="nav-link body-3 montserrat-400" 
            id="item2-tab" 
            data-bs-toggle="tab" data-bs-target="#item2-tab-pane" 
            type="button" role="tab" 
            aria-controls="item2-tab-pane" aria-selected="false">Item 2
        </button>
    </li>
</ul>
<div class="tab-content" id="myTabContent">
    <div class="tab-pane fade show active" id="item1-tab-pane" role="tabpanel" aria-labelledby="item1-tab" tabindex="0">
        Contenido item 1
    </div>
    <div class="tab-pane fade" id="item2-tab-pane" role="tabpanel" aria-labelledby="item2-tab" tabindex="0">
        Contenido item 2
    </div>
</div>
</script></code></pre>
            </div>

            <!--  -->
            <h4>Tabs Verticales</h4>
            <p class="text-dark my-0">Reemplazar la clase <code>tabs-default-siahe</code> que se encuentra en la etiqueta <code>ul</code> por la clase <code>tabs-vertical-siahe</code>  para apilar las opciones.</p>
            <!-- Implementación -->
            <div class="row mt-3 mb-4">
                <div class="col-md-2">
                    <ul class="tabs-vertical-siahe nav nav-tabs" id="myTabVertical" role="tablist">
                        <li class="nav-item" role="presentation">
                            <button class="nav-link active body-3 montserrat-400" id="link1-tab" data-bs-toggle="tab" data-bs-target="#link1-tab-pane" type="button" role="tab" aria-controls="link1-tab-pane" aria-selected="true">Item 1</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link body-3 montserrat-400" id="link2-tab" data-bs-toggle="tab" data-bs-target="#link2-tab-pane" type="button" role="tab" aria-controls="link2-tab-pane" aria-selected="false">Item 2</button>
                        </li>
                        <li class="nav-item" role="presentation">
                            <button class="nav-link body-3 montserrat-400" id="link3-tab" data-bs-toggle="tab" data-bs-target="#link3-tab-pane" type="button" role="tab" aria-controls="link3-tab-pane" aria-selected="false">Item 3</button>
                        </li>
                    </ul>
                </div>
                <div class="col-md-10 border-start">
                    <div class="tab-content mt-2" id="myTabContentColumn">
                        <div class="tab-pane fade show active" id="link1-tab-pane" role="tabpanel" aria-labelledby="item1-tab" tabindex="0">Contenido item 1</div>
                        <div class="tab-pane fade" id="link2-tab-pane" role="tabpanel" aria-labelledby="item2-tab" tabindex="0">Contenido item 2</div>
                        <div class="tab-pane fade" id="link3-tab-pane" role="tabpanel" aria-labelledby="item3-tab" tabindex="0">Contenido item 3</div>
                    </div>
                </div>
            </div>
            <!-- CODIGO QUE SE MUESTRA -->
            <p class="text-dark my-0">Agregar todo el contenido anterior dentro de un div contenedor con la clase <code>row</code> asi tambien agregar el contenido de las etiquetas <code>ul</code> y <code>div class="tab-content"</code> 
            en un div con la clase <code>col-md-2</code> y <code>col-md-10 border-start</code> respectivamente para tener las opciones y el contenido en forma de columnas.</p>    
            <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><div class="row">
    <div class="col-md-2">
        <ul class="tabs-vertical-siahe nav nav-tabs" id="myTabVertical" role="tablist">
            <li class="nav-item" role="presentation">
                <button 
                    class="nav-link active body-3 montserrat-400" 
                    id="item1-tab" 
                    data-bs-toggle="tab" data-bs-target="#item1-tab-pane" 
                    type="button" role="tab" aria-controls="item1-tab-pane" aria-selected="true">Item 1
                </button>
            </li>
        </ul>
    </div>
    <div class="col-md-10 border-start">
        <div class="tab-content" id="myTabContentColumn">
            <div 
                class="tab-pane fade show active" 
                id="item1-tab-pane" 
                role="tabpanel" 
                aria-labelledby="item1-tab" tabindex="0"> Contenido item 1
            </div>
        </div>
    </div>
</div>
</script></code></pre>
            </div>
            

            <h4>Tabs deshabilitadas</h4>
            <!-- Implementación -->
            <p class="text-dark my-0 mb-2">Añadir la clase <code>disabled</code> al <code>button</code> del tab para deshabilitar esa opción</p>
            <ul class="tabs-default-siahe nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item" role="presentation">
                    <button class="nav-link active body-3 montserrat-400" id="item1-tab" data-bs-toggle="tab" data-bs-target="#item1-tab-pane" type="button" role="tab" aria-controls="item1-tab-pane" aria-selected="true">Item 1</button>
                </li>
                <li class="nav-item" role="presentation">
                    <button class="nav-link body-3 montserrat-400" id="disabled-tab" data-bs-toggle="tab" data-bs-target="#disabled-tab-pane" type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false" disabled>Disabled</button>
                </li>
            </ul>
            <!-- CODIGO HTML -->
            <div v-highlight>
<pre class="language-html"><code><script type="text/plain" class="language-markup"><li class="nav-item" role="presentation">
    <button
        disabled
        class="nav-link body-3 montserrat-400"
        id="disabled-tab"
        data-bs-toggle="tab" data-bs-target="#disabled-tab-pane"
        type="button" role="tab" aria-controls="disabled-tab-pane" aria-selected="false" >Disabled
    </button>
</li>
</script></code></pre>
            </div>
        </section>
    </div>
</template>

<script>
    export default{
        created(){
            window.scrollTo(0, 0);
        },
        data:function(){
            return{
               
            }
        }
    }
</script>